import postscribe from 'postscribe';
import AbstractDriver from './abstract-driver';

/* eslint no-undef: "error" */
class Segment extends AbstractDriver
{
    constructor()
    {
        super();
        this.firstLoad = false;
    }

    init(config)
    {
        if (!this.firstLoad)
            this._loadScript(config);
    }

    async pageView()
    {
        //do nothing
    }

    async lead()
    {
        //do nothing
    }

    _exists(showErrors = false)
    {
        return true;
    }

    _loadScript(config)
    {
        postscribe(document.querySelector('head'), `
            <!-- Segment -->
            <script type="text/javascript"> !function(){var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on","addSourceMiddleware","addIntegrationMiddleware","setAnonymousId","addDestinationMiddleware"];analytics.factory=function(e){return function(){var t=Array.prototype.slice.call(arguments);t.unshift(e);analytics.push(t);return analytics}};for(var e=0;e<analytics.methods.length;e++){var key=analytics.methods[e];analytics[key]=analytics.factory(key)}analytics.load=function(key,e){var t=document.createElement("script");t.type="text/javascript";t.async=!0;t.src="https://cdn.segment.com/analytics.js/v1/" + key + "/analytics.min.js";var n=document.getElementsByTagName("script")[0];n.parentNode.insertBefore(t,n);analytics._loadOptions=e};analytics._writeKey="bLnNAvRehzCeE0VFGyxvubwMJFv0BndX";;analytics.SNIPPET_VERSION="4.15.3"; analytics.load("bLnNAvRehzCeE0VFGyxvubwMJFv0BndX"); analytics.page(); }}(); </script>
            <!-- Segment -->
        `, {
            done: () =>
            {
                this.firstLoad = true;
                this.init(config);
            },
        });

        return true;
    }
}

export default Segment;
